import { render, staticRenderFns } from "./ProfessionalsForm.vue?vue&type=template&id=2116424b"
import script from "./ProfessionalsForm.vue?vue&type=script&lang=js"
export * from "./ProfessionalsForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports